module.exports = global["$"] = require("-!/var/www/html/node_modules/expose-loader/index.js?jQuery!/var/www/html/node_modules/jquery/dist/jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js
// module id = 1
// module chunks = 1